import React, { useCallback } from "react";
import { FaAngleDoubleDown } from "react-icons/fa";
import { Stack, Flex, Text, Box } from "@chakra-ui/react";
import NextImage from "next/image";
import Router from "next-translate/Router";
import useTranslation from "next-translate/useTranslation";
import * as Texts from "src/shared/components/Texts";
import { UDINI_HOME_ROUTE } from "src/utils/constants/routes";
import { IS_HYBRIDGE } from "src/modules/smile/shared/consts";
import { SmileSignUpSteps } from "../../..";

const SmileSignupLeftContentView = ({ step }: { step: SmileSignUpSteps }) => {
  const { t } = useTranslation();

  const handleGotoHome = useCallback(() => {
    Router.pushI18n(UDINI_HOME_ROUTE);
  }, []);

  if (IS_HYBRIDGE) {
    return (
      <Flex h={"100%"} alignItems={"center"} justifyContent={"center"} position={"relative"} my={"37px"}>
        <Box my={"150px"}>
          <NextImage src="/svg/hybridge-logo.svg" alt="Hybridge logo" width="232px" height="62px" priority />
        </Box>
      </Flex>
    );
  }

  return (
    <Flex
      flexDirection="column"
      align="flex-start"
      width="100%"
      pl={{ base: "16px", md: "56px" }}
      pt={{ base: "42px", md: "47px" }}
      pb="47px"
      h="100%"
    >
      <Box
        display={{ base: "block", sm: "none" }}
        w={{ base: "100px", sm: "115px" }}
        mb={{ base: "45px", md: "unset" }}
        cursor={"pointer"}
        onClick={handleGotoHome}
      >
        <NextImage src="/svg/SmilePlusProductLogoWhite.svg" alt="Smile+ logo" width="150px" height="45px" priority />
      </Box>
      <Box
        display={{ base: "none", sm: "block" }}
        w={{ base: "100px", sm: "115px" }}
        mb={{ base: "45px", md: "unset" }}
        cursor={"pointer"}
        onClick={handleGotoHome}
      >
        <NextImage src="/svg/SmilePlusProductLogo.svg" alt="Smile+ logo" width="150px" height="45px" priority />
      </Box>
      <Stack flex={1} pl={{ md: "63px" }} pr={{ md: "109px" }} maxWidth="100%" h="400px" justifyContent="center">
        <Texts.H1 mb={{ base: "20px", sm: "10px" }}>{t(`smile:smilePlusSignUp_leftViewTitle${step + 1}`)}</Texts.H1>
        <Box maxW="600px">
          <Texts.Large>{t(`smile:smilePlusSignUp_leftViewText${step + 1}`)}</Texts.Large>
        </Box>
      </Stack>
      <Box
        display={{ base: "none", sm: "block" }}
        w={{ base: "90px", sm: "95px" }}
        mt={{ base: "55px", md: "unset" }}
        cursor={"pointer"}
        onClick={handleGotoHome}
      >
        <NextImage src="/svg/udini-logo-dental-ai.svg" alt="Udini logo" width="150px" height="75px" priority />
      </Box>
      <Flex justify={"center"} w={"100%"} pr={"16px"} mt={"150px"} display={{ base: "flex", sm: "none" }}>
        <FaAngleDoubleDown size={"24px"} />
      </Flex>
    </Flex>
  );
};

export default SmileSignupLeftContentView;
